

import * as React from "react";
import * as Layout$RecountTools from "../../layout/Layout.bs.js";
import * as PageHistory$RecountTools from "../../util/PageHistory.bs.js";

function Page_NotFound(Props) {
  PageHistory$RecountTools.revertPage(undefined);
  return React.createElement(Layout$RecountTools.AppContainer.make, {
              children: React.createElement(Layout$RecountTools.Columns.make, {
                    children: React.createElement(Layout$RecountTools.Columns.Column.make, {
                          children: "Page Not Found"
                        })
                  }),
              pageName: "Page Not Found"
            });
}

var make = Page_NotFound;

export {
  make ,
  
}
/* react Not a pure module */
